import logo from './logo.svg';
import './App.css';

import RssFeedDisplay from './components/RssFeedDisplay';
import SpanishLinks from './components/links/SpanishLinks';
import SpanishLinksTable from './components/SpanishLinksTable/SpanishLinksTable';
import RssNewsGrid from './components/RssNewsGrid/RssNewsGrid';
function App() {
  return (
    <div className="App">
      {/* {    <RssFeedDisplay/>  }   */}
      { <RssNewsGrid/> }
      { <SpanishLinks/>  }
    {     <SpanishLinksTable/> }

    </div>
  );
}

export default App;
